import {
  inchesToPaperValue,
  stationeryNumbers,
} from "../../../../data/stationery";
import { stdObject } from "../../../../data/types/stdObject";

export const convertPaperValue = (
  code: string,
  value: any,
  params: stdObject,
) => {
  const { staValues, setStaValues, handleActive } = params;
  if (code === "FOMDOC" && !value) {
    handleActive({ code: "FORMNUMBER", partType: 2 }, false);
  }
  staValues.data[code] = stationeryNumbers.includes(code)
    ? inchesToPaperValue(value)
    : value;
  setStaValues({ ...staValues });
  return true;
};
